(() => {
  if (customElements.get('breaker-menu-position')) return;
  class BreakerMenuPosition extends HTMLElement {
    connectedCallback() {
      if (!this.closest('.breaker-menu-section')) return;
      this.align = () => {
        const section = this.closest('.breaker-menu-section');
        const trigger = section?.parentElement.querySelector(':scope > .list-item-link');
        if (!section || !trigger) return;
        const container = section.querySelector('.section-container');
        const containerRect = container.getBoundingClientRect();
        const scale = container.offsetWidth ? containerRect.width / container.offsetWidth : 1;
        const left = Math.min(trigger.getBoundingClientRect().left, document.documentElement.clientWidth - containerRect.width - 16);
        container.style.marginLeft = `${(Math.max(16, left) - section.getBoundingClientRect().left) / scale}px`;
      };
      this.resizeObserver = new ResizeObserver(this.align);
      this.resizeObserver.observe(document.documentElement);
      this.align();
      document.fonts?.ready.then(() => { if (this.isConnected) this.align(); });
    }
    disconnectedCallback() { this.resizeObserver?.disconnect(); }
  }
  customElements.define('breaker-menu-position', BreakerMenuPosition);
})();
